<!--充电机数据 -->
<template>
  <div>
    <!-- 列表 -->
    <div id="btUpdateInfo" style="position: relative;">
      <el-table id="btUpdateInfoTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="configTime" :label="$t('warningPage.CreatedAt')" align="center" />
        <el-table-column prop="versionOld" :label="$t('adminView.FWBeforeUpdate')" align="center" />
        <el-table-column prop="versionNew" :label="$t('adminView.FWVersionUpdate')" align="center" />
        <el-table-column prop="remark" :label="$t('warningPage.Remark')" align="center" />
        <el-table-column prop="updateBy" :label="$t('adminView.UpdateBy')" align="center" />
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList"
            :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { chargerFirmwareVersionConfig } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'
import i18n from '@/i18n'
import { getDateAndHour, howLongAgo } from '@/utils/updateTime.js'

export default {
  props: {
    activeTab: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      tableData: []
    }
  },
  watch: {
    activeTab(newValue, oldValue) {
      if (newValue == 'fwPane') this.queryList()
    },
    version(newValue, oldValue) {
      if (newValue) {
        this.version = newValue.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      if (this.activeTab == 'fwPane') this.queryList()
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      var param = {
        'deviceModel': 'CHARGER12',
        'deviceVersion': this.version,
        chargerSn: this.$route.query.chargerSn,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      // console.log(this.selectDay)
      if (this.selectDay && this.selectDay.length > 0) {
        param.startDate = new Date(this.selectDay[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      }
      chargerFirmwareVersionConfig(param).then(res => { // 基本信息
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          this.tableData = res.resultModel.list || []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData.forEach((v, i) => {
            if (v.configTime)v.configTime = getDateAndHour(new Date(v.configTime).getTime())
          })
        }
      })
    },
    // 筛选改变事件
    changeSearch() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>
